export default {
  title: "Messaggio Chats",
  form: {
    email: {
      label: "Email",
      placeholder: "Введіть Ваш Email",
    },
    password: {
      label: "Пароль",
      placeholder: "Введіть Ваш пароль",
    },
    confirmation: {
      label: 'Код Google Auth',
      placeholder: 'Введіть код Google Auth',
    },
    button: {
      text: "Увійти",
      text_mode_otp: "Увійти",
    },
    forgotlink: "Забули Ваш пароль?"
  },
  signuptext: "не маєте акаунту ?",
  signuplink: "Зареєструватися зараз",
  oauth_loading: 'OAuth завантажується ...',

  errors: {
    max_rate_limiting_reached: {
      title: 'Досягнуто максимальну кількість спроб, будь ласка, спробуйте пізніше',
    },
    error403: {
      title: 'Помилка авторизації',
      description: 'Логін або пароль невірні. Будь ласка, перевірте та спробуйте ще.',
    },
  },
}
